import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    OnDestroy,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';

import { ListService, UserTicketAction, BaseComponent } from '@ridango/core';
import { keyCode } from '@ridango/core/lib/enums/keyboard.enum';

import { TicketFocusService } from '../../ticket-focus.service';
import { takeUntil } from 'rxjs/operators';
let identifier = 0;

@Component({
    selector: 'ridango-ticket-actions-dropdown',
    templateUrl: './ticket-actions-dropdown.component.html',
    styleUrls: ['./ticket-actions-dropdown.component.css']
})
export class TicketActionsDropdownComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() actions: UserTicketAction[];
    @Input() locale;
    @Input() type = 'REGULAR'; // FIXME: remove this shit when templates get corrected
    @Input() showDropdownAlways = false;

    @Output() actionClicked: EventEmitter<UserTicketAction> = new EventEmitter<UserTicketAction>();

    @ViewChild('actionLink') actionLinkEl: ElementRef;
    @ViewChild('menuList') menuListEl: ElementRef;
    @ViewChild('menuButton') menuButton: ElementRef;
    @ViewChildren('menuItem') menuItems: QueryList<ElementRef>;

    isOpened = false;
    selectedIndex = 0;

    menuButtonId = `actions-menu-button-${++identifier}`;
    menuId = `actions-menu-${identifier}`;

    constructor(
        public eRef: ElementRef,
        private listService: ListService,
        private focusService: TicketFocusService
    ) {
        super();
    }

    ngOnInit() {
        this.focusService.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
            if (this.menuItems.length > 1) {
                setTimeout(() => this.menuButton.nativeElement.focus());
            } else {
                this.actionLinkEl.nativeElement.focus();
            }
        });
    }

    @HostListener('document:click', ['$event']) onClickOut(event) {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.isOpened = false;
        }
    }

    click(action: UserTicketAction, event?: KeyboardEvent): void {
        if (event) {
            // prevent key (space) from scrolling the page down
            event.preventDefault();
        }
        this.isOpened = false;
        this.actionClicked.emit(action);
    }

    openClicked(): void {
        this.isOpened = !this.isOpened;
        if (this.isOpened) {
            setTimeout(() => this.menuItems.toArray()[this.selectedIndex].nativeElement.focus());
        }
    }

    closeMenu(): void {
        this.isOpened = false;
        this.selectedIndex = 0;
        // this is now handled in subscribe
        // setTimeout(() => this.menuItems.first.nativeElement.focus());
    }

    onMenuItemKeyDown(event: KeyboardEvent, action: UserTicketAction) {
        switch (event.keyCode) {
            case keyCode.ENTER:
            case keyCode.SPACE:
                event.preventDefault();
                this.click(action);
                break;
            case keyCode.ESCAPE:
            case keyCode.TAB:
                this.closeMenu();
                break;
            case keyCode.ARROW_DOWN:
                event.preventDefault();
                this.selectNextItem(1);
                break;
            case keyCode.ARROW_UP:
                event.preventDefault();
                this.selectNextItem(-1);
                break;
        }
    }

    selectNextItem(direction: number): void {
        this.selectedIndex = this.listService.getNextCyclicIndex(this.selectedIndex, direction, this.actions.length);
        this.menuItems.toArray()[this.selectedIndex].nativeElement.focus();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
